const SEO_CONTENT = {
  fr: {
    siteName: "Stephane Kamwa",
    personTitle: "Vidéo, Photographie, Design graphique & Réseaux sociaux | Stephane Kamwa Darmstadt & Francfort",
    defaultDescription:
      "Production professionnelle de vidéos et de photographies, design graphique et création de contenu pour les réseaux sociaux à Darmstadt et Francfort. J’aide les entreprises à gagner en visibilité, attirer des clients et renforcer leur marque. Je propose des services professionnels en production vidéo, photographie, design graphique et création de contenu pour les réseaux sociaux à Darmstadt, Francfort et dans toute la région Rhin-Main. Demandez dès maintenant, sans engagement !",
    defaultKeywords:
      "Stephane Kamwa, freelance, réalisateur, photographe, directeur artistique, production vidéo, photographie, branding, design, communication visuelle, production vidéo Darmstadt, photographe Francfort, graphiste freelance Allemagne, création de contenu pour les réseaux sociaux, créateur de contenu freelance, design de marque Allemagne, vidéaste Francfort, photographe Darmstadt, freelance réseaux sociaux Hesse",
    pages: {
      home: {
        title: "Vidéo, Photographie, Design graphique & Réseaux sociaux | Stephane Kamwa Darmstadt & Francfort",
        description:
          "Stephane Kamwa accompagne marques, entreprises et talents avec une approche freelance en production vidéo, photographie, direction artistique, branding et design.",
        keywords:
          "Stephane Kamwa, freelance, réalisateur, photographe, direction artistique, branding, design, production vidéo"
      },
      about: {
        title: "À propos",
        description:
          "Découvrez le parcours, l'expertise et l'approche de Stephane Kamwa, freelance en image, direction artistique et communication visuelle. Je crée du contenu qui capte l’attention, inspire confiance et attire des clients.",
        keywords:
          "à propos Stephane Kamwa, freelance créatif, réalisateur freelance, photographe freelance, directeur artistique"
      },
      services: {
        title: "Vidéo, Photographie, Design graphique, Réseaux sociaux",
        description:
          "Production vidéo, photographie, direction artistique, branding et accompagnement créatif pour marques, entreprises et talents.",
        keywords:
          "services freelance, production vidéo, photographie, branding, direction artistique, design visuel"
      },
      portfolio: {
        title: "Portfolio",
        description:
          "Découvrez une sélection de projets signés Stephane Kamwa : vidéo, photo, identité visuelle, branding et contenus de communication.",
        keywords:
          "portfolio Stephane Kamwa, projets vidéo, projets photo, branding, identité visuelle, direction artistique"
      },
      contact: {
        title: "Contact",
        description:
          "Parlez-moi de votre projet et échangeons sur vos besoins en vidéo, photographie, direction artistique ou branding.",
        keywords:
          "contact Stephane Kamwa, devis vidéo, devis photo, freelance créatif, accompagnement branding"
      },
      blog: {
        title: "Blog",
        description:
          "Articles et réflexions autour de la création visuelle, de la communication, du branding et de la production.",
        keywords:
          "blog création visuelle, communication, branding, production vidéo, photographie, direction artistique"
      },
      videoProduction: {
        title: "Production vidéo freelance",
        description:
          "Films de marque, interviews, contenus publicitaires et productions sur mesure réalisés par Stephane Kamwa.",
        keywords:
          "production vidéo freelance, réalisateur freelance, films de marque, interview, publicité, captation"
      },
      impressum: {
        title: "Mentions légales",
        description:
          "Informations légales et mentions légales du site de Stephane Kamwa.",
        keywords:
          "mentions légales, informations légales, Stephane Kamwa"
      },
      protectionData: {
        title: "Politique de confidentialité",
        description:
          "Politique de confidentialité et informations sur la protection des données.",
        keywords:
          "politique de confidentialité, protection des données, vie privée"
      },
      notFound: {
        title: "Page introuvable",
        description: "La page demandée est introuvable.",
        keywords: "404, page introuvable, Stephane Kamwa"
      }
    }
  },
  en: {
    siteName: "Stephane Kamwa",
    personTitle: "Video, Photography, Graphic Design & Social Media | Stephane Kamwa Darmstadt & Frankfurt",
    defaultDescription:
      "Professional video and photography production, graphic design and social media content in Darmstadt & Frankfurt. I help businesses increase their visibility, attract customers and strengthen their brand. I offer professional services in video production, photography, graphic design and social media in Darmstadt, Frankfurt and across the entire Rhine-Main area. Get in touch now with no obligation!",
    defaultKeywords:
      "Stephane Kamwa, freelance filmmaker, photographer, art director, video production, photography, branding, design, visual communication, video production Darmstadt, photographer Frankfurt, freelance graphic designer Germany, social media content creation, freelance content creator, branding design Germany, videographer Frankfurt, photographer Darmstadt, freelance social media specialist Hesse",
    pages: {
      home: {
        title: "Video, Photography, Graphic Design & Social Media | Stephane Kamwa Darmstadt & Frankfurt",
        description:
          "Stephane Kamwa supports brands, companies and talents with a freelance approach to video production, photography, art direction, branding and design.",
        keywords:
          "Stephane Kamwa, freelance filmmaker, freelance photographer, art direction, branding, design, video production"
      },
      about: {
        title: "About",
        description:
          "Discover Stephane Kamwa's background, expertise and personal approach to image-making, art direction and visual communication. I create content that captures attention, builds trust and attracts customers.",
        keywords:
          "about Stephane Kamwa, freelance creative, filmmaker, photographer, art director"
      },
      services: {
        title: "Video, Photography, Graphic Design, Social Media",
        description:
          "Video production, photography, art direction, branding and creative support for brands, companies and talents.",
        keywords:
          "freelance services, video production, photography, branding, art direction, visual design"
      },
      portfolio: {
        title: "Portfolio",
        description:
          "Browse a selection of Stephane Kamwa's work across video, photography, visual identity, branding and communication content.",
        keywords:
          "Stephane Kamwa portfolio, video projects, photo projects, branding, visual identity, art direction"
      },
      contact: {
        title: "Contact",
        description:
          "Let's talk about your project and your needs in video, photography, art direction or branding.",
        keywords:
          "contact Stephane Kamwa, video quote, photo quote, freelance creative, branding support"
      },
      blog: {
        title: "Blog",
        description:
          "Articles and thoughts on visual creation, communication, branding and production.",
        keywords:
          "visual creation blog, communication, branding, video production, photography, art direction"
      },
      videoProduction: {
        title: "Freelance video production",
        description:
          "Brand films, interviews, ads and custom video productions created by Stephane Kamwa.",
        keywords:
          "freelance video production, filmmaker, brand film, interview, ad video, shoot"
      },
      impressum: {
        title: "Impressum",
        description:
          "Legal information and site notice for Stephane Kamwa.",
        keywords: "impressum, legal notice, Stephane Kamwa"
      },
      protectionData: {
        title: "Privacy policy",
        description:
          "Privacy policy and information about data protection.",
        keywords: "privacy policy, data protection, personal data"
      },
      notFound: {
        title: "Page not found",
        description: "The requested page could not be found.",
        keywords: "404, page not found, Stephane Kamwa"
      }
    }
  },
  de: {
    siteName: "Stephane Kamwa",
    personTitle: "Video, Fotografie, Grafikdesign & Social Media | Stephane Kamwa Darmstadt & Frankfurt",
    defaultDescription:
      "Professionelle Video- und Fotoproduktion, Grafikdesign und Social Media Content in Darmstadt & Frankfurt. Ich helfe Unternehmen, sichtbar zu werden, Kunden zu gewinnen und ihre Marke zu stärken. Ich biete professionelle Dienstleistungen in den Bereichen Videoproduktion, Fotografie, Grafikdesign und Social Media in Darmstadt, Frankfurt und im gesamten Rhein-Main-Gebiet an. Jetzt unverbindlich anfragen!",
    defaultKeywords:
      "Stephane Kamwa, Freelancer, Filmemacher, Fotograf, Art Director, Videoproduktion, Fotografie, Branding, Design, visuelle Kommunikation, Videoproduktion Darmstadt, Fotograf Frankfurt, Grafikdesigner Freelancer Deutschland, Social Media Content Erstellung, Content Creator Freelancer, Branding Design Deutschland, Videograf Frankfurt, Fotograf Darmstadt, Social Media Freelancer Hessen",
    pages: {
      home: {
        title: "Video, Fotografie, Grafikdesign & Social Media | Stephane Kamwa Darmstadt & Frankfurt",
        description:
          "Stephane Kamwa begleitet Marken, Unternehmen und Talente freiberuflich in Videoproduktion, Fotografie, Art Direction, Branding und Design.",
        keywords:
          "Stephane Kamwa, freiberuflicher Filmemacher, Fotograf, Art Director, Branding, Design, Videoproduktion"
      },
      about: {
        title: "Über mich",
        description:
          "Entdecken Sie den Werdegang, die Expertise und den persönlichen Ansatz von Stephane Kamwa in Bildgestaltung, Art Direction und visueller Kommunikation. Ich erstelle Inhalte, die Aufmerksamkeit erzeugen, Vertrauen aufbauen und Kunden gewinnen.",
        keywords:
          "über Stephane Kamwa, Freelancer Kreativer, Filmemacher, Fotograf, Art Director"
      },
      services: {
        title: "Video, Fotografie, Grafikdesign, Social Media",
        description:
          "Videoproduktion, Fotografie, Art Direction, Branding und kreative Begleitung für Marken, Unternehmen und Talente.",
        keywords:
          "Freelance Leistungen, Videoproduktion, Fotografie, Branding, Art Direction, visuelles Design"
      },
      portfolio: {
        title: "Portfolio",
        description:
          "Entdecken Sie eine Auswahl an Projekten von Stephane Kamwa aus Video, Fotografie, visueller Identität, Branding und Kommunikationsinhalten.",
        keywords:
          "Stephane Kamwa Portfolio, Videoprojekte, Fotoprojekte, Branding, visuelle Identität, Art Direction"
      },
      contact: {
        title: "Kontakt",
        description:
          "Sprechen wir über Ihr Projekt und Ihre Anforderungen in Video, Fotografie, Art Direction oder Branding.",
        keywords:
          "Kontakt Stephane Kamwa, Videoproduktion Angebot, Foto Angebot, Freelancer Kreativer, Branding Begleitung"
      },
      blog: {
        title: "Blog",
        description:
          "Artikel und Gedanken zu visueller Gestaltung, Kommunikation, Branding und Produktion.",
        keywords:
          "Blog visuelle Gestaltung, Kommunikation, Branding, Videoproduktion, Fotografie, Art Direction"
      },
      videoProduction: {
        title: "Freie Videoproduktion",
        description:
          "Brandfilme, Interviews, Werbeinhalte und maßgeschneiderte Videoproduktionen von Stephane Kamwa.",
        keywords:
          "Videoproduktion Freelancer, Filmemacher, Brandfilm, Interview, Werbevideo, Dreh"
      },
      impressum: {
        title: "Impressum",
        description:
          "Rechtliche Informationen und Impressum der Website von Stephane Kamwa.",
        keywords: "Impressum, rechtliche Informationen, Stephane Kamwa"
      },
      protectionData: {
        title: "Datenschutzerklärung",
        description:
          "Datenschutzerklärung und Informationen zum Datenschutz.",
        keywords: "Datenschutz, Datenschutzerklärung, personenbezogene Daten"
      },
      notFound: {
        title: "Seite nicht gefunden",
        description: "Die angeforderte Seite konnte nicht gefunden werden.",
        keywords: "404, Seite nicht gefunden, Stephane Kamwa"
      }
    }
  }
};

export function normalizeLanguage(language = "en") {
  return String(language).toLowerCase().split("-")[0];
}

export function getSiteSeo(language) {
  return SEO_CONTENT[normalizeLanguage(language)] || SEO_CONTENT.en;
}

export function getPageSeo(language, pageKey) {
  const siteSeo = getSiteSeo(language);
  return siteSeo.pages[pageKey] || siteSeo.pages.home;
}

export function getLocaleCode(language) {
  const normalizedLanguage = normalizeLanguage(language);
  const localeMap = {
    fr: "fr_FR",
    en: "en_US",
    de: "de_DE"
  };

  return localeMap[normalizedLanguage] || localeMap.en;
}

export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", maxLength = 160) {
  const normalizedValue = String(value).trim();

  if (!normalizedValue || normalizedValue.length <= maxLength) {
    return normalizedValue;
  }

  const shortenedValue = normalizedValue.slice(0, maxLength).trim();
  const lastSpace = shortenedValue.lastIndexOf(" ");
  const safeValue =
    lastSpace > 80 ? shortenedValue.slice(0, lastSpace) : shortenedValue;

  return `${safeValue.trim()}...`;
}
